import { apiFetch } from './apiFetch';

export async function fetchMessageTemplates() {
  const response = await apiFetch('/msg');
  if (!response.ok) {
    throw new Error('Failed to fetch message templates');
  }
  return response.json();
}
